// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { mergeWithCss } from "@sc/XDL/Utilities/mergeWithCss";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

// XNG-Change
interface OwnProps extends WidgetProps {
    extendedStyles?: PageTitleStyles;
}

// Xng-Changes: SC-516 - adding styling
export interface PageTitleStyles {
    title?: TypographyPresentationProps;
}

// Xng-Changes: SC-516 - adding styling
export const pageTitleStyles: PageTitleStyles = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const PageTitle: React.FunctionComponent<Props> = ({ pageTitle, fields, extendedStyles }: Props) => {
    // XNG-Change
    const [styles] = React.useState(() => mergeWithCss(pageTitleStyles, extendedStyles));

    // Xng-Changes: SC-516 - adding styling
    return(<Typography variant="h1" data-test-selector="PageTitle" {...styles.title}>
        {fields.overrideTitle || pageTitle}
    </Typography>);
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PageTitle),
    definition: {
        group: "Basic",
        icon: "heading",
    },
};

export default widgetModule;
